export const appGoogleDriveIcon = {
    data: `<svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M44.52 28H30.99L17.71 5h11.221c1.429 0 2.749.762 3.464 2L44.52 28zM44.32 31l-5.766 9.998C37.84 42.237 36.519 43 35.089 43H11.71l6.93-12H44.32zM22.21 18.8L9.15 41.42l-5.766-9.99c-.714-1.238-.714-2.762 0-4L15.29 6.81 22.21 18.8z"/></svg>`,
    name: 'google-drive'
};